/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Patient API
 * API for Patient
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PutFamilyPharmacistQuestionnaireRequestBodyTypename =
  "PutFamilyPharmacistQuestionnaireRequestBody" as const;

/**
 *
 * @export
 * @interface PutFamilyPharmacistQuestionnaireRequestBody
 */
export interface PutFamilyPharmacistQuestionnaireRequestBody {
  /**
   *
   * @type {string}
   * @memberof PutFamilyPharmacistQuestionnaireRequestBody
   */
  answer: PutFamilyPharmacistQuestionnaireRequestBodyAnswerEnum;
  /**
   * Resource type name
   * @type {string}
   * @memberof PutFamilyPharmacistQuestionnaireRequestBody
   */
  readonly __typename?: string;
}

/**
 * @export
 * @enum {string}
 */
export enum PutFamilyPharmacistQuestionnaireRequestBodyAnswerEnum {
  WantingToHear = "wanting_to_hear",
  ActivelyLookingFor = "actively_looking_for",
  AlreadyRegistered = "already_registered",
  Uninteresting = "uninteresting",
}

export function PutFamilyPharmacistQuestionnaireRequestBodyFromJSON(
  json: any
): PutFamilyPharmacistQuestionnaireRequestBody {
  return PutFamilyPharmacistQuestionnaireRequestBodyFromJSONTyped(json, false);
}

export function PutFamilyPharmacistQuestionnaireRequestBodyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PutFamilyPharmacistQuestionnaireRequestBody {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PutFamilyPharmacistQuestionnaireRequestBodyTypename,

    answer: json["answer"],
  };
}

export function PutFamilyPharmacistQuestionnaireRequestBodyToJSON(
  object?: PutFamilyPharmacistQuestionnaireRequestBody | null
): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    answer: value.answer,
  };
}
